import $ from 'jquery';

import '@fontsource/fira-sans/300.css';
import '@fontsource/fira-sans/400.css';
import '@fontsource/fira-sans/700.css';
import '@fontsource/fira-sans/900.css';

window.$ = $;

import 'bootstrap';
import '../vendor/jquery.ujs';
import '../subscriptions/plan_fields';
import '../subscriptions/billing_fields';
import '../sign_up/referral_fields.js';

console.log('Vite ⚡️ Rails')
